import { Component, ViewContainerRef } from '@angular/core';
import { WidgetService } from '../../../services/widget/widget.service';
import { CategoryService } from '../../../services/category/category.service';
import { BrandService } from '../../../services/brand/brand.service';
import { WidgetTemplate } from '../../../models/widget/widget-template.model';
import { WidgetContent } from '../../../models/widget/widget-content.model';
import { PageWidget } from '../../../models/widget/page-widget.model';
import { DynamicPage } from '../../../models/widget/dynamic-page.model';
import { Brand } from '../../../models/brand/brand-model';
import { Category } from '../../../models/category/category.model';
import { DisplayCategory } from '../../../models/category/DisplayCategory.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../../services/role/role-permission.service';

@Component({
  selector: 'app-parent-sort-widgets',
  templateUrl: './parent-sort-widgets.component.html',
  styleUrls: ['./parent-sort-widgets.component.css']
})
/** parent-sort-widgets component*/
export class ParentSortWidgetsComponent {
  public widgetTemplateList: WidgetTemplate[];
  public pageWidget = new PageWidget();
  public widgetContentList: WidgetContent[] = [];
  public widgetContent = new WidgetContent();
  public dynamicPageList: DynamicPage[];
  public pageWidgetList: PageWidget[];
  multipleWidgetItems: MultipleWidgetItems[] = [];
  public categoryList: Category[] = [];
  public subCategoryList: Category[] = [];
  public parentCategoryList: Category[];
  public SubcategoryList: Category[];
  public ThirdLevelcategoryList: Category[];
  public allCategoriesList: Category[];
  public selectedPopualarCategoryIds: any[] = [];
  public displaySubcategoryList: DisplayCategory[] = [];
  public Brands: Brand[];
  brandTab = new BrandTabsList();
  customDPage: string;
  widgetTemplateID: number;
  isPageSelected: boolean = true;
  selectedBrandImageLeft: string[];
  selectedBrandImageRight: string[];
  selectedCategoryImage2: string[];
  selectedCategoryImage: string[];
  selectedBannerImage: string[];
  selectedILoveAppBannerImage: string[];
  public sortOrderData: string = "";
  /** parent-sort-widgets ctor */
  config = {
    displayKey: "name", //if objects array passed which key to be displayed defaults to description
    search: true,
  };
  sortedList: any;
  listStyle = {
    height: '250px',
    width: '100%',
    dropZoneHeight: '100px'
  }
  constructor(private readonly widgetService: WidgetService,
    private readonly categoryService: CategoryService,
    private readonly brandsService: BrandService, private readonly router: Router,
    private readonly toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService) {
    //this.sortedList = this.options;
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.GetDynamicPages();
    this.GetAllBrands();
    this.GetCategoryList();
    this.GetDisplaySubcategoryList();
    this.GetWidgetTemplates();
    this.customDPage = "";
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("widgetSort").subscribe(
      data => {
        if (data != null) {
          var create = data.filter(function (element) {
            return (element.action == "parentSort");
          });

          if (create.length > 0) {

          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  listSorted(list: any) {
    this.sortedList = list;
  }
  GetDynamicPages() {
    this.widgetService.GetDynamicPages().subscribe(
      data => {
        this.dynamicPageList = data;
      }
    )
  }
  GetAllBrands() {
    this.brandsService.getBrand().subscribe(
      data => {
        this.Brands = data;
      }

    )
  }

  GetCategoryList() {
    this.categoryService.GetAllCategoryList().subscribe(
      data => {
        this.categoryList = data;
        this.allCategoriesList = data;
        this.subCategoryList = this.allCategoriesList.filter(s => s.isParent == false);
        this.parentCategoryList = this.allCategoriesList.filter(s => s.parentCategoryID == 0);
      }
    )
  }
  GetDisplaySubcategoryList() {
    this.categoryService.GetDisplaySubcategoryList().subscribe(
      data => {
        this.displaySubcategoryList = data;
      }
    )
  }
  GetWidgetTemplates() {
    this.widgetService.GetWidgetTemplates().subscribe(
      data => {
        this.widgetTemplateList = data;
        
      }
    )
  }
  enumSelector(enumName) {
    return Object.keys(enumName)
      .map(key => ({ value: key, title: enumName[key] }));
  }
  WidgetContentInitialization() {
    this.selectedCategoryImage = [];
    this.selectedBrandImageLeft = [];
    this.selectedBrandImageRight = [];
    this.pageWidget = new PageWidget();
    this.widgetContentList = [];
    this.selectedPopualarCategoryIds = [];
    this.selectedBannerImage = [];
    this.selectedILoveAppBannerImage = [];
  }
  LaodSavedWidgets() {
    this.isPageSelected = true;
    // check to load all widgets of page
    this.WidgetContentInitialization();
    this.sortedList = [];

    this.widgetService.GetSortedPageWidgetsByPageID(parseInt(this.customDPage), 0).subscribe(
      data => {
        
        this.pageWidgetList = data;
        this.sortedList = this.pageWidgetList;
        for (var p = 0; p < this.pageWidgetList.length; p++) {
          this.pageWidgetList[p].index = p;
          //Intialization of Multiple widgets
          this.multipleWidgetItems[p] = new MultipleWidgetItems();
          // For Category List
          this.multipleWidgetItems[p].categoryBrandsList = [];
          this.multipleWidgetItems[p].thumbnailCategoryList = [];
          this.multipleWidgetItems[p].menuParentCategoryList = [];
          this.multipleWidgetItems[p].menuCategoryList = [];
          this.multipleWidgetItems[p].menuSubcategoryList = [];
          // For Popular Category Widget
          this.multipleWidgetItems[p].popularCategoryList = [];
          // For Brands
          this.multipleWidgetItems[p].brandTabsList = [];
          this.pageWidget.widgetTemplateID = this.pageWidgetList[p].widgetTemplateID;
          this.pageWidget.sortOrder = this.pageWidgetList[p].sortOrder;
          this.pageWidget.pageWidgetID = this.pageWidgetList[p].pageWidgetID;
          // retaining PageWID To check product widget
          //end for product widget
          this.pageWidget.id = this.pageWidgetList[p].id;
          this.widgetContentList = this.pageWidgetList[p].widgetContentList;
          var widgetTemplate = this.widgetTemplateList.find(s => s.widgetTemplateID == this.pageWidgetList[p].widgetTemplateID)
          if (widgetTemplate != null) {
            if (widgetTemplate.widgetType == WidgetTypes.Brands.toString()) {
              //this.brandTabsList = [];
              for (var i = 0; i < this.widgetContentList.length; i++) {
                //check if template is Brand Widget
                if (this.widgetContentList[i].type == WidgetContentTypes.HeroImage.toString()) {
                  // Data Structure BrandLeft: Url, Image" 
                  let arrData = this.PipeSignSpliter(this.widgetContentList[i].data);
                  let arrUrlAndImage = this.CommaSpliter(arrData[1]);
                  if (arrData[0].toString() == WidgetImageContents.BrandLeft.toString()) {
                    this.selectedBrandImageLeft[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];

                  } else if (arrData[0].toString() == WidgetImageContents.BrandRight.toString()) {
                    this.selectedBrandImageRight[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];
                  }

                } else if (this.widgetContentList[i].type == WidgetContentTypes.BrandTab.toString()) {
                  let arrBrandTabs = this.PipeSignSpliter(this.widgetContentList[i].data);
                  for (var j = 0; j < arrBrandTabs.length; j++) {
                    let arrTabAndIds = this.ColonSpliter(arrBrandTabs[j]);
                    
                    this.brandTab = new BrandTabsList();
                    this.brandTab.tabTitle = arrTabAndIds[0];
                    let existingBrandIds = this.CommaSpliter(arrTabAndIds[1]);
                    for (var k = 0; k < existingBrandIds.length; k++) {
                      var selectedbrand = this.Brands.find(s => s.brandID == parseInt(existingBrandIds[k]));
                      
                      this.brandTab.BrandsList.push(selectedbrand);
                    }
                    this.multipleWidgetItems[p].brandTabsList.push(this.brandTab);
                  }

                }
              }

            } else if (widgetTemplate.widgetType == WidgetTypes.Category1.toString() || widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
              // Load at page change
              // check to show all pages
              for (var cate1Index = 0; cate1Index < this.widgetContentList.length; cate1Index++) {
                if (this.widgetContentList[cate1Index].type == WidgetContentTypes.HeroImage.toString()) {
                  let arrUrlAndImage = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  this.selectedCategoryImage[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.CategoryBannerBrands.toString()) {
                  let arrBrandIds = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  for (var i = 0; i < arrBrandIds.length; i++) {
                    var selectedbrand = this.Brands.find(s => s.brandID == parseInt(arrBrandIds[i]));
                    this.multipleWidgetItems[p].categoryBrandsList.push(selectedbrand);
                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.ThumbnailCategoryList.toString()) {
                  let arrThumbnailCatIds = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                    var selectedCategory = this.subCategoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                    this.multipleWidgetItems[p].thumbnailCategoryList.push(selectedCategory);
                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.CategoryMenu.toString()) {
                  let arrCateMenuIds = this.CommaSpliter(this.widgetContentList[cate1Index].data);
                  for (var i = 0; i < arrCateMenuIds.length; i++) {
                    //populate the left Menu with items
                    var category = this.categoryList.find(s => s.categoryID == parseInt(arrCateMenuIds[i]));
                    if (category.parentCategoryID == 0) {
                      this.multipleWidgetItems[p].menuParentCategoryList.push(category);
                    } else if (category.isParent == true && category.parentCategoryID > 0) {
                      this.multipleWidgetItems[p].menuCategoryList.push(category);
                    } else if (category.isParent == false) {
                      this.multipleWidgetItems[p].menuSubcategoryList.push(category);
                    }

                  }
                }

              }
            } else if (widgetTemplate.widgetType == WidgetTypes.PopularCategory.toString()) {
              for (var popularCatIndex = 0; popularCatIndex < this.widgetContentList.length; popularCatIndex++) {
                let arrThumbnailCatIds = this.CommaSpliter(this.widgetContentList[popularCatIndex].data);
                for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                  var selectedPopularCategory = this.displaySubcategoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                  this.multipleWidgetItems[p].popularCategoryList.push(selectedPopularCategory);
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.BestVendor.toString()) {
              for (var vendorIndex = 0; vendorIndex < this.widgetContentList.length; vendorIndex++) {
                //this.widgetContentTypeVendorId = this.widgetContentList[vendorIndex].widgetContentID;
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.Products.toString()) {
              for (var ProductIndex = 0; ProductIndex < this.widgetContentList.length; ProductIndex++) {
                //this.widgetContentList[ProductIndex].type;
                //if (this.widgetContentList[ProductIndex].type == WidgetContentTypes.FlashSaleProducts.toString()) {
                //  //this.saleId = parseInt(this.PipeSignSpliter(this.widgetContentList[ProductIndex].data)[0]);
                //}
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.Banner.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                let arrUrlAndImage = this.CommaSpliter(this.widgetContentList[bannerIndex].data);
                this.selectedBannerImage[p] = "Images/WidgetContentImages/" + arrUrlAndImage[1];
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.ILoveAppBanner.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                this.selectedILoveAppBannerImage[p] = "Images/WidgetContentImages/" + this.widgetContentList[bannerIndex].data;
              }
            }
          }
        }
      });
  }

  UpdateSorting() {
    if (this.customDPage == "") {
      this.isPageSelected = false;
      return;
    } else {
      this.isPageSelected = true;
      this.sortOrderData = "";
      for (var i = 0; i < this.sortedList.length; i++) {
        let pageWID = this.sortedList[i].id; // pageWidgetID
        let sortOrder = this.sortedList.indexOf(this.sortedList[i]);
        this.sortOrderData += "|" + pageWID + ":" + parseInt(sortOrder + 1);
      }
      // Data structure for sortOrderData => PageWidgetID:SortOrder|PageWidgetID:SortOrder
      this.sortOrderData = this.sortOrderData.substring(1);
      
      this.widgetService.UpdateWidgetSorting(this.sortOrderData).subscribe(result => {
        
        this.sortedList = [];
        this.router.navigate(["/page-widget-list"]);
      });

    }
    this.toastr.success('Widgets Sorted successfully.', 'Success');
  }
  //common functions
  PipeSignSpliter(str: string): string[] {
    return str != "" ? str.toString().split('|') : [];
  }

  ColonSpliter(str: string): string[] {
    return str != "" ? str.toString().split(':') : [];
  }
  CommaSpliter(str: string): string[] {
    return str != "" ? str.toString().split(',') : [];
  }
}
enum WidgetImageContents {
  BrandLeft = "BrandLeft",
  BrandRight = "BrandRight",
  DummyPath = "DummyPath",
  Category = "Category",
}
enum WidgetContentTypes {

  CategoryMenu = "Category Menu",
  HeroImage = "Hero Image",
  ThumbnailCategoryList = "Thumbnail Category List",
  CategoryBannerBrands = "Category Banner Brands",
  BrandTab = "Brand Tab",
  Banner = "Banner",
  BestVendors = "Best Vendors",
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
enum WidgetTypes {

  Category1 = "Category1",
  Category2 = "Category2",
  PopularCategory = "PopularCategory",
  Products = "Products",
  Brands = "Brands",
  BestVendor = "BestVendor",
  Banner = "Banner",
  ILoveAppBanner = "ILoveAppBanner",
}
enum ProductWidgetTypes {
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
export class BrandTabsList {
  public tabTitle: string;
  public BrandsList: Brand[] = [];
}
// For showing multiple widgets
export class MultipleWidgetItems {
  // For Template Id 1 & 2
  public categoryBrandsList: Brand[] = [];
  public thumbnailCategoryList: Category[] = [];
  public menuParentCategoryList: Category[] = [];
  public menuCategoryList: Category[] = [];
  public menuSubcategoryList: Category[] = [];
  //For Popular Category widget
  public popularCategoryList: DisplayCategory[] = [];
  // For Brands
  public brandTabsList: BrandTabsList[] = [];

}



// WEBPACK FOOTER //
// ./src/app/widget/sort-widgets/parent-sort-widgets/parent-sort-widgets.component.ts